import React, { PureComponent } from 'react';
import {
  SearchMagnifier,
} from 'AppSrc/core/components/common/svg-icons';
import { withRouter } from 'react-router';
import ReactRouterPropTypes from 'react-router-prop-types';
import { MIN_CRQ_ID_CHARS } from 'AppSrc/core/components/search-crqs-screen/search-crqs-screen';
import 'AppSrc/core/style/components/header/header-search.css';
import { SEARCH_CRQS } from '../router/routes';


class HeaderSearchDisplay extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
    };
    this.updateSearchQuery = this.updateSearchQuery.bind(this);
    this.isQueryValid = this.isQueryValid.bind(this);
    this.performSearch = this.performSearch.bind(this);
  }

  updateSearchQuery(event) {
    const searchQuery = event.target.value;
    this.setState({ searchQuery });
  }

  // is the current typed in search query valid for a search
  isQueryValid() {
    const { searchQuery } = this.state;
    return searchQuery && searchQuery.length >= MIN_CRQ_ID_CHARS;
  }

  performSearch(event) {
    event.preventDefault();
    // no op if the query isn't valid;
    if (!this.isQueryValid()) {
      return null;
    }
    const { searchQuery } = this.state;
    const searchPath = SEARCH_CRQS.getPath(searchQuery);
    this.props.history.push(searchPath);
    this.setState({ searchQuery: '' });
    return null;
  }

  render() {
    const { searchQuery } = this.state;
    const validQuery = this.isQueryValid();
    // FN: 04/04/2020
    // ie11 and safari expect disabled to be disabled='disabled' as opposed to disabled=true
    const buttonDisabled = validQuery ? false : 'disabled';

    return (
      <div className="header-search-container">
        <form
          // using form and onsubmit to properly handle enter key
          onSubmit={this.performSearch}
        >
          <div className="header-search">
            <input
              className="header-search-input"
              type="text"
              placeholder="Search CRQ ID"
              value={searchQuery}
              onChange={this.updateSearchQuery}
              onKeyDown={this.handleKeyDown}
            />
            <div className="header-search-svg">
              <button
                type="submit"
                disabled={buttonDisabled}
              >
                <SearchMagnifier />
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

HeaderSearchDisplay.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

const HeaderSearch = withRouter(HeaderSearchDisplay);

export { HeaderSearch };
